import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import jsPDF from "jspdf";
import "../../../../assets/css/style.css";
import ResumeTemplate1 from "./templates/ResumeTemplate1";
import ResumeTemplate2 from "./templates/ResumeTemplate2";
import ResumeTemplate7 from "./templates/ResumeTemplate7";
import ResumeTemplate3 from "./templates/ResumeTemplate3";
import ResumeTemplate4 from "./templates/ResumeTemplate4";
import ResumeTemplate5 from "./templates/ResumeTemplate5";
import ResumeTemplate6 from "./templates/ResumeTemplate6";

const ResumePreviewPage = () => {
  const { templateId } = useParams();

  return (
    <>
      {templateId === "1" ? (
        <ResumeTemplate1 />
      ) : templateId === "2" ? (
        <ResumeTemplate2 />
      ) : templateId === "3" ? (
        <ResumeTemplate3 />
      ) : templateId === "4" ? (
        <ResumeTemplate4 />
      ) : templateId === "5" ? (
        <ResumeTemplate5 />
      ) : templateId === "6" ? (
        <ResumeTemplate6 />
      ) : (
        <ResumeTemplate7 />
      )}
    </>
  );
};

export default ResumePreviewPage;
